// extracted by mini-css-extract-plugin
export default {"container":"_1wpUI","videoEmbed":"xNOni","large":"_3sZUX","title":"_3lStC","content":"_2BLi7","separator":"_2z9aW","metaContainer":"UDg-B","text":"_1m07C"};